import React from 'react';
import { ArrowRight } from 'react-feather';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageMeta } from './PageMeta';
import { OG_IMAGE, HERO_WATERMARK } from '../constants/assets';
interface HomePageProps {
  onNavigate: (page: string) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <div className="relative flex flex-col min-h-screen" data-id="element-60">
      {/* Background watermark — right-aligned, vertically centred */}
      <img src={HERO_WATERMARK} alt="" aria-hidden="true" className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-[60vh] w-auto object-contain pointer-events-none select-none z-0" data-id="element-61" />

      <PageMeta title="Designer. Doer. Systems Thinker." description="I work where policy, technology, and human judgement meet." url="https://mintextract.design" ogImage={OG_IMAGE} data-id="element-62" />
      <Header data-id="element-63" />

      <main className="relative z-10 flex-1 w-full flex items-center" data-id="element-64">
        <div className="w-full px-8 py-12 md:py-16" data-id="element-65">
          <div className="max-w-[1200px] mx-auto" data-id="element-66">
            <h1 className="flex text-fluid-3xl md:text-[clamp(4.209rem,5vw,5.61rem)] font-bold mb-8 uppercase animate-fadeIn flex-col tracking-tight" data-id="element-67">
              <span className="mb-2" data-id="element-68">G'day, I'm W.</span>
              <span data-id="element-69">Designer. Doer.</span>
            </h1>

            <div className="text-[1.1rem] md:text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)] text-[#7A8290] animate-fadeIn flex flex-col gap-3" data-id="element-70">
              <span className="block" data-id="element-71">
                I work where policy, technology, and human judgement meet.
              </span>
              <span className="block" data-id="element-72">My focus:</span>
              <ul className="flex flex-col gap-3 items-start" aria-label="Areas of specialization" data-id="element-73">
                <li className="hover:translate-x-2 transition-all duration-300 block group" data-id="element-74">
                  <a href="/complexity" onClick={e => {
                  e.preventDefault();
                  onNavigate('complexity');
                }} className="inline-flex items-center gap-2 text-[#7A8290] hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-white/20 focus:ring-offset-1 focus:ring-offset-[#111111] rounded-sm whitespace-nowrap" aria-label="The problem behind the problem" data-id="element-75">
                    The problem behind the problem
                    <ArrowRight size={18} strokeWidth={2} className="shrink-0" aria-hidden="true" data-id="element-76" />
                  </a>
                </li>
                <li className="hover:translate-x-2 transition-all duration-300 block group" data-id="element-77">
                  <a href="/research" onClick={e => {
                  e.preventDefault();
                  onNavigate('research');
                }} className="inline-flex items-center gap-2 text-[#7A8290] hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-white/20 focus:ring-offset-1 focus:ring-offset-[#111111] rounded-sm whitespace-nowrap" aria-label="Turning research into decisions" data-id="element-78">
                    Turning research into decisions
                    <ArrowRight size={18} strokeWidth={2} className="shrink-0" aria-hidden="true" data-id="element-79" />
                  </a>
                </li>
                <li className="hover:translate-x-2 transition-all duration-300 block group" data-id="element-80">
                  <a href="/systems" onClick={e => {
                  e.preventDefault();
                  onNavigate('systems');
                }} className="inline-flex items-center gap-2 text-[#7A8290] hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-white/20 focus:ring-offset-1 focus:ring-offset-[#111111] rounded-sm whitespace-nowrap" aria-label="Building systems that last" data-id="element-81">
                    Building systems that last
                    <ArrowRight size={18} strokeWidth={2} className="shrink-0" aria-hidden="true" data-id="element-82" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-83" />
    </div>;
}